<span *ngIf="fieldAttribute.backendAttribute.label" class="pt-3 d-flex fw-bolder" [class.is-invalid]="isFieldInvalid()">
  {{ fieldAttribute.backendAttribute.label | translate }}
</span>
<div
  *ngIf="!fieldAttribute.hidden"
  [attr.data-test-id]="'wrap-checkbox-' + fieldAttribute.elementDataTestId"
  [formGroup]="form"
  [ngClass]="fieldAttribute.elementStyles.containerStyle"
>
  <input
    [class.is-invalid]="isFieldInvalid()"
    [ngClass]="fieldAttribute.elementStyles.contentStyle"
    [type]="fieldAttribute.backendAttribute.type_attribute"
    [formControlName]="fieldAttribute.backendAttribute.name"
    [id]="fieldAttribute.id"
    [attr.data-test-id]="fieldAttribute.elementDataTestId"
    [checked]="checked"
    (change)="toggleControl($event.target.checked)"
  />
  <label class="form-label" [for]="fieldAttribute.id" [ngClass]="fieldAttribute.elementStyles.labelStyle">
    {{ fieldAttribute.backendAttribute.placeholder | translate }}
    <span *ngIf="fieldAttribute.backendAttribute.required">*</span>
  </label>
</div>
<small
  *ngIf="form.get(fieldAttribute.backendAttribute.name) && form.get(fieldAttribute.backendAttribute.name).invalid"
  class="d-flex mt-1 invalid-feedback"
  [attr.data-test-id]="fieldAttribute.errorDataTestId"
>
  {{ getValidationError(form.get(fieldAttribute.backendAttribute.name)) | translate }}
</small>
